import styles from './Checkbox.module.scss'

export const Checkbox = ({ value, label, onChange, isChecked, color = '#ed1c25' }) => {
  return (
    <div className={styles.checkboxContainer}>
      <input
        className={styles.checkboxInput}
        type='checkbox'
        checked={isChecked}
        onChange={onChange}
        value={value}
        style={{ '--checkbox-checked-color': color }}
      />
      <label className={styles.checkboxLabel}>{label}</label>
    </div>
  )
}
